import {
  Breadcrumbs,
  BreadcrumbsData,
  Container,
  Footer,
  Header,
  HnaviHeader,
  HeaderCategoryMenuCategories,
  Seo2,
  SeoData,
} from '@components';

export const Layout2: React.FC<{
  breadcrumbs?: BreadcrumbsData | null;
  categories?: HeaderCategoryMenuCategories | null;
  footer?: React.ReactElement;
  pageTitle?: string | null;
  seoData?: SeoData | null;
  sideBar?: React.ReactElement;
  useHnaviHeader?: boolean;
  wrapLogoByH1Tag?: boolean;
}> = ({
  breadcrumbs,
  categories,
  children,
  footer,
  pageTitle,
  seoData,
  sideBar,
  useHnaviHeader,
  wrapLogoByH1Tag,
}) => (
  <>
    {useHnaviHeader ? (
      <HnaviHeader />
    ) : (
      <Header categories={categories} wrapLogoByH1Tag={wrapLogoByH1Tag} />
    )}
    <div className='min-h-screen'>
      <main>
        <Seo2 {...seoData} />
        <Container>
          <div className='lg:flex lg:content-around'>
            <section className='lg:w-[720px]'>
              {breadcrumbs && (
                <div className='mb-2 text-sm lg:mb-8'>
                  <Breadcrumbs data={breadcrumbs} />
                </div>
              )}
              {pageTitle && (
                <h1 className='mb-8 text-center text-2xl font-bold'>
                  {pageTitle}
                </h1>
              )}
              {children}
            </section>
            <section className='mt-4 md:mt-0 lg:ml-12 lg:w-[270px] lg:flex-none'>
              {sideBar}
            </section>
          </div>
        </Container>
        {footer}
      </main>
    </div>
    <Footer />
  </>
);
